import app from '../../app';
import { BooleanGambit } from '../IGambit';
export default class UnreadGambit extends BooleanGambit {
  key() {
    return app.translator.trans('core.lib.gambits.discussions.unread.key', {}, true);
  }
  canonicalKey() {
    return 'unread';
  }
  filterKey() {
    return 'unread';
  }
  enabled() {
    return !!app.session.user;
  }
}
flarum.reg.add('core', 'common/query/discussions/UnreadGambit', UnreadGambit);